import create, { SetState } from 'zustand';

export interface IUserStore {
  readonly id?: string;
  readonly isReady: boolean;
  login?(id: string): void;
  logout?(): void;
  setReady(): void;
}

export const [useUserStore, userStoreApi /* TODO: remove when migration is finished */] = create<IUserStore>(
  (set: SetState<IUserStore>) => ({
    id: null,
    isReady: false,
    login: (id: string) =>
      set(() => {
        return {
          id,
        };
      }),
    logout: () =>
      set(() => {
        return {
          id: null,
          user: null,
        };
      }),
    setReady: () =>
      set(() => {
        return {
          isReady: true,
        };
      }),
  })
);
